import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class BanksService {
  constructor(private http: HttpClientService) {}

  public getIndex(): Observable<any> {
    return this.http.get("/api/banks").pipe(tap((_) => console.log("BanksService.getIndex: Ok.")));
  }
}
